import React from 'react';
export function AnkhLogo({
  className = 'w-16 h-16'
}: {
  className?: string;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/3sFHuXnuhzPJ6ct858q919/WhatsApp_Image_2026-04-22_at_4.06.48_PM.jpg" alt="Logo" className={className} style={{
    objectFit: 'contain',
    mixBlendMode: 'lighten'
  }} data-id="element-17" data-mp="11j4hvasakj2k" />;
}